import React from 'react';           //all files that have react containers
import ReactDom from 'react-dom';    //hook the element in react is going to be stored

import App from './App';


ReactDom.render(<App />, document.getElementById('root'));